<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>通用管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>错误日志</a>
<!--          @click="jumpTo('/index_reco_list')"-->
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="filters.typeId"
              placeholder="请选择"
            >
              <el-option
                    label="待处理"
                    value="1"
                  ></el-option>
                  <el-option
                    label="已处理"
                    value="2"
                  ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="error_name"
            label="异常名称"
          >
          </el-table-column>

          <el-table-column
            prop="request_param"
            label="请求参数"
          >
          </el-table-column>

          <el-table-column
            prop="request_url"
            label="请求接口地址"
          >
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="时间"
          >
          </el-table-column>

          <el-table-column
            prop="info_type"
            label="状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">待处理</span>
              <span v-if="scope.row.status == 2">已处理</span>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template>
                <el-button
                  @click="addPostDialog(scope.row)"
                  type="text"
                  size="small"
                >查看明细</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="详情"
      :visible.sync="dialogAddVisible"
      width="80%"
    >
    <div style='height:600px;overflow: auto;'>
      <span style="color:red">异常名称：{{msgData.error_name}}</span><br/>
      <span style="color:red">请求参数:{{msgData.request_param}}</span><br/>
      <span style="color:red">请求接口地址：{{msgData.request_url}}</span><br/>
      <span style="color:red">报错时间：{{msgData.create_time}}</span><br/>
      <div
          v-for="item in msgInfo"
          v-bind:key="item"
        ><span>{{item}}</span><br /></div>
    </div>
      
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../bus.js";
import API from "../api/api_user";
import {dateFunc} from "../dateFunc"
var _ = require("lodash");
export default {
  name: "bankList",
  created() {
  },
  data() {
    return {
      tableHeight:null,
      addFormRule: {

        key_name: [
          { required: true, message: "请输入热搜词", trigger: "blur" }
        ],
        push_status: [
          { required: true, message: "请选择是否立即推荐", trigger: "blur" }
        ]
      },
      addLoading: false,
      msgInfo:[],
      msgData:{},
      form: {
        push_status: null,
        key_name: null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        startTime: null,
        endTime: null,
        typeId: '1'
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      recoOptions: [
        { text: "待上架", value: "1" },
        { text: "立即上架", value: "2" }
      ],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      userList: [
        {
          id: 1,
          username: "登录日志"
        }
      ]
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.pic = e.data;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      }
    },
    addPostDialog(row) {
      let that = this;
      that.addLoading = true;
          let para = {
            token:localStorage.getItem("api_token"),
            id:row.id
          };
          API.error_log_detail(para)
            .then(
              function(result) {
                if (result.key == 1000) {
                  
                that.dialogAddVisible = true;
                  that.msgInfo = JSON.parse(result.result.data.errorMsg);
                  that.msgData = row;
                } else if (result.key == 2981) {
                  that.$message.error({
                    showClose: true,
                    message: result.message,
                    duration: 1500
                  });
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }

              },
              function(err) {
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }
      if (that.filters.typeId) {
        params.status = that.filters.typeId;
      }
      that.loading = true;
      API.error_log_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                console.log(result)
                for (var i=0; i<result.result.list.length; i++){
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/errorLog.vue